import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { ReactionEffects } from './store/reaction.effects';
import { ReactionNamespace, ReactionReducer } from './store/reactions.store';

@NgModule({
  imports: [
    StoreModule.forFeature(ReactionNamespace, ReactionReducer),
    EffectsModule.forFeature([ReactionEffects]),
  ],
})
export class ReactionsDataModule {}
